window.arSalesInvoiceCreditedForFormatter = function(value, row) {
    let html = '';
    if (row.credited_for) {
        html += '<a href="/ar/sales/invoices/show/'+row.credited_for_id+'">';
        html += row.credited_for;
        html += '</a>';
    }
    return html;
}
